<template>
  <div class="statisticsChart">
    <div class="monthly-chart-title" ref="titleBackground">{{titleName}}: ￥{{totalAmount}}元</div>
    <div id="dateChart"></div>
    <div class="x-y-text" ref="x-yAirs">
      <p class="yellow">本月当前收入<span>↑</span></p>
      <p class="green">本月当前日期<span>→</span></p>
    </div>
  </div>
</template>

<script>
export default {
  props:['date','data','name'],
  data(){
    return{
      titleName: '总营业额'
    }
  },
  methods:{
    drawChart(theme,discoloration){
      if(!theme) theme = '#E60202';
      if(!discoloration) discoloration = '#FF8181';
      let myChart = this.$echarts.init(document.getElementById('dateChart'));
      window.onresize = function () {
        myChart.resize();
      }
      const createSvg = (shadowColor, shadowBlur) => `
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
            x="0px" y="0px" 
            viewBox="0 0 32 128"
            xml:space="preserve"
        >
          <style>
            .st2 {
                fill: transparent;
                stroke: ${shadowColor};
                stroke-width: ${shadowBlur}px;
                filter: url(#chart-inset-shadow);
            }
          </style>
          <defs>
            <filter id="chart-inset-shadow" width="200%" height="200%" x="-50%" y="-50%">
              <feGaussianBlur in="SourceGraphic" result="gass" stdDeviation="${shadowBlur * 0.75}" />
              <feMerge>
                <feMergeNode in="gass" />
              </feMerge>
            </filter>
          </defs>
          <path class="st2" d="M0 0 L32 0 L32 128 L0 128 Z" />
        </svg>
      `;

      const svgString = createSvg('#156dff', 3);
      const svg = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});

      const DOMURL = window.URL || window.webkitURL || window;
      const insetShadowUrl = DOMURL.createObjectURL(svg);
      //绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        xAxis: {
          data: this.date,
          axisLabel: {
            borderColor: theme,
            borderWidth: 3,
            lineHeight: 34,
            color: "#80F6FF",
            position: "bottom",
            offset: 10,
            padding: [0,5,0,5],
            shadowColor: '#000',
            shadowBlur: 6,
            shadowOffsetX: 0,
            shadowOffsetY: 0
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          scale: true,
          type: 'value',
          minInterval:1,
          axisLabel: {
            borderColor: theme,
            borderWidth: 3,
            lineHeight: 17,
            color: "#FFFA80",
            verticalAlign: "bottom",
            formatter: name => (`{name|${name}}`),
            rich: {
              name: {
                width: 100,
                align: "center"
              }
            },
            shadowColor: '#000',
            shadowBlur: 6,
            shadowOffsetX: 0,
            shadowOffsetY: 0
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '当月收入统计',
            data: this.data,
            type: 'bar',
            barMaxWidth: '50',
            label: {
              show: true,
              position: 'top',
              textStyle: { //数值样式
                color: '#fff',
                fontSize: 16
              },
              // formatter: '{c} 元'
            },
            itemStyle: {
              color: 'transparent',
              borderWidth: 3,
              borderColor: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {
                    offset: 0,
                    color: discoloration
                  },
                  {
                    offset: 1,
                    color: theme
                  },
                ]
              ),
              shadowColor: '#000',
              shadowBlur: 12,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
          },
        ],
        grid: {
          left: 120,
          right: 20,
          top: 30,
          bottom: 50
        }
      });
    }
  },
  watch:{
    data(val){
      this.drawChart();
    },
    date(val){
      this.drawChart();
    },
    name(val,oldVal){
      this.titleName = val;
      if(!val) this.titleName = oldVal;
      switch(val){
        case '总营业额':
          this.drawChart('#E60202','#FF8181');
          this.$refs['x-yAirs'].style.borderColor = '#E60202';
          this.$refs.titleBackground.style.background = '#E60202'
        break;
        case '实际收入':
          this.drawChart('#FE5002','#FFD64C');
          this.$refs['x-yAirs'].style.borderColor = '#FE5002';
          this.$refs.titleBackground.style.background = '#FE5002'
        break;
        case '线上收入':
          this.drawChart('#00AE5A','#B8FFD5');
          this.$refs['x-yAirs'].style.borderColor = '#00AE5A';
          this.$refs.titleBackground.style.background = '#00AE5A'
        break;
        case '线下收入':
          this.drawChart('#00A5FF','#B3FDFF');
          this.$refs['x-yAirs'].style.borderColor = '#00A5FF';
          this.$refs.titleBackground.style.background = '#00A5FF'
        break;
        case '球台':
          this.drawChart('#FFDD00','#FDFFB3');
          this.$refs['x-yAirs'].style.borderColor = '#FFDD00';
          this.$refs.titleBackground.style.background = '#FFDD00'
        break;
        case '商品':
          this.drawChart('#FF0095','#FFB3DC');
          this.$refs['x-yAirs'].style.borderColor = '#FF0095';
          this.$refs.titleBackground.style.background = '#FF0095'
        break;
        case '充值':
          this.drawChart('#00FFED','#C5FFF8');
          this.$refs['x-yAirs'].style.borderColor = '#00FFED';
          this.$refs.titleBackground.style.background = '#00FFED'
        break;
      }
    }
  },
  computed:{
    totalAmount(){
      let amount = 0;
      this.data.forEach(item => {
        amount += item
      });
      return amount.toFixed(2)
    }
  },
  mounted(){
    this.drawChart()
  }
}
</script>

<style lang="scss" scoped>
.statisticsChart{
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .monthly-chart-title{
    width: 200px;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    background: #E60202;
    font-size: 14px;
    margin: 9px 0 0 9px;
    box-shadow: 2px 2px 5px #000 inset,-2px -2px 5px #000 inset;
  }
  #dateChart{
    height: calc(100% - 41px);
    width: 100%;
  }
  .x-y-text{
    position: absolute;
    width: 104px;
    height: 37px;
    border: 3px solid #E60202;
    bottom: 6px;
    left: 10px;
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0px 0px 10px #000 inset,0px 0px 10px #000;
    .yellow{
      color: #FFFA80;
      font-size: 12px;
      text-align: center;
      line-height: 17px;
      display: flex;
      justify-content: space-between;
    }
    .green{
      color: #80F6FF;
      font-size: 12px;
      text-align: center;
      line-height: 17px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>